import React from 'react';

/**
 * Upload progress bar and label.
 * Only rendered when progress is set.
 * Shows byte-level percent if available, falls back to file-index percent.
 * @param {{ fileName: string, current: number, total: number, percent?: number }} progress
 */
export default function UploadProgress({ progress }) {
    if (!progress) return null;

    const { fileName, current, total } = progress;

    // Use byte-level percent from XHR if available — fallback to file index fraction
    const percent = progress.percent ?? Math.round((current / total) * 100);

    const label = total === 1
        ? `Uploading ${fileName} — ${percent}%`
        : `Uploading ${fileName} (${current}/${total}) — ${percent}%`;

    return (
        <div id="upload-progress-root" className="upload-progress-root">
            <div className="upload-progress-label">{label}</div>
            <div className="upload-progress-bar-wrap">
                <div
                    className="upload-progress-bar"
                    style={{ width: `${percent}%` }}
                />
            </div>
        </div>
    );
}
